import {
  InterfaceIDistributive, InterfacePlatformAlphaItem,
  InterfacePlatformChange,
  InterfacePlatformChangeItem,
} from '../../interface/platform/interface.platform';
import { DownloadPlatformPageService } from '../../pages/download/download.platform.page.service';
import { numberSystemDecimal, searchParams, webApi } from '../../common/consts';
import moment, { Moment } from 'moment';

export class DownloadPlatformChaneComponent {


  constructor(
    private loader: HTMLElement | null,
    private platformId: number,
    private modalContentTo: HTMLElement | null,
    private modalOpenItem: HTMLElement | null = null,
  ) {}

  public initialize(): void {
    const platformsElement: HTMLInputElement | null = document.querySelector('[data-platforms-json]')

    if (platformsElement) {
      const platformsItems = JSON.parse(platformsElement.value)?.Platforms
      const platforms =  platformsItems.map((platform: InterfacePlatformAlphaItem) => platform.Name);

      if (platforms.includes(this.modalOpenItem?.dataset?.modalOpen)) {

        let platformId = this.platformId;
        const platformIdQueryParam: string | null  = searchParams.get('platformId');
        if (platformIdQueryParam) {
          platformId = parseInt(platformIdQueryParam, numberSystemDecimal);
        }
        const downloadPlatformPageService = new DownloadPlatformPageService(this.loader);

        downloadPlatformPageService.getPlatformChanges(platformId).then((data: InterfacePlatformChange | null) => {
          let versionGanges = '';
          if (this.modalContentTo && data?.Changes) {

            data?.Changes.forEach((change: InterfacePlatformChangeItem) => {
              let distributives = '';
              change.Distributives.forEach((distributive: InterfaceIDistributive) => {
                distributives += `
              <a href="${webApi}/WebApi/Platforms/Download/${distributive.Id}" class="link-with-download">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_7094_71847)">
                    <path d="M15 11.25C15.1989 11.25 15.3897 11.329 15.5303 11.4697C15.671 11.6103 15.75
                     11.8011 15.75 12V15C15.75 15.3978 15.592 15.7794 15.3107 16.0607C15.0294 16.342 14.6478
                      16.5 14.25 16.5H3.75C3.35218 16.5 2.97064 16.342 2.68934 16.0607C2.40804 15.7794 2.25
                       15.3978 2.25 15V12C2.25 11.8011 2.32902 11.6103 2.46967 11.4697C2.61032 11.329 2.80109
                        11.25 3 11.25C3.19891 11.25 3.38968 11.329 3.53033 11.4697C3.67098 11.6103 3.75 11.8011
                         3.75 12V15H14.25V12C14.25 11.8011 14.329 11.6103 14.4697 11.4697C14.6103 11.329 14.8011
                          11.25 15 11.25ZM9 1.5C9.19891 1.5 9.38968 1.57902 9.53033 1.71967C9.67098 1.86032 9.75
                           2.05109 9.75 2.25V9.93225L11.652 8.03025C11.7212 7.95862 11.8039 7.90148 11.8954
                            7.86217C11.9869 7.82287 12.0854 7.80218 12.1849 7.80131C12.2845 7.80045 12.3833
                             7.81942 12.4755 7.85713C12.5676 7.89484 12.6514 7.95053 12.7218 8.02095C12.7922 8.09137
                              12.8479 8.17511 12.8856 8.26728C12.9233 8.35946 12.9423 8.45822 12.9414 8.5578C12.9406
                               8.65739 12.9199 8.7558 12.8806 8.8473C12.8413 8.93881 12.7841 9.02156 12.7125
                                9.09075L9.663 12.1403C9.57594 12.2273 9.47258 12.2964 9.35882 12.3435C9.24506
                                 12.3907 9.12314 12.4149 9 12.4149C8.87686 12.4149 8.75494 12.3907 8.64118
                                  12.3435C8.52742 12.2964 8.42406 12.2273 8.337 12.1403L5.2875 9.09075C5.21587
                                   9.02156 5.15873 8.93881 5.11942 8.8473C5.08012 8.7558 5.05943 8.65739 5.05856
                                    8.5578C5.0577 8.45822 5.07667 8.35946 5.11438 8.26728C5.15209 8.17511 5.20778
                                     8.09137 5.2782 8.02095C5.34862 7.95053 5.43236 7.89484 5.52453 7.85713C5.61671
                                      7.81942 5.71547 7.80045 5.81505 7.80131C5.91464 7.80218 6.01305 7.82287 6.10455
                                       7.86217C6.19606 7.90148 6.27881 7.95862 6.348 8.03025L8.25 9.93225V2.25C8.25
                                        2.05109 8.32902 1.86032 8.46967 1.71967C8.61032 1.57902 8.80109 1.5 9 1.5Z"
                                         fill="#2195F2"
                                         />
                  </g>
                  <defs>
                    <clipPath id="clip0_7094_71847">
                      <rect width="18" height="18" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
                ${distributive.Title}
              </a>
            `
              });
              const rawVersionDate: Moment = moment(change.Date, 'DD.MM.YYYY HH:mm:ss');
              versionGanges += `
            <div class="mb-25">
              <div class="download__version-data mb-25">
                <h4>
                  Ассистент ${ change.Version }
                </h4>
                <p>Дата релиза: ${moment(rawVersionDate).format('DD.MM.YYYY')}</p>
              </div>
              <p class="mb-10">${change?.Text.replace(/<\/p>/g, '\n')
                .replace(/<[^>]*>/g, '')
                .trim()
                .replace(/\r?\n/g, '<br>')}
              </p>
              
              <div class="download__versions-links">
                ${distributives}
              </div>
            </div>
          `;
            });
            this.modalContentTo.innerHTML =
            `
              <div class="modal__body-item download__versions">
                  ${versionGanges}
              </div>
            `;
          }
        });
      }
    }
  }
}
